import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    antecedentesHeredoFamiliares: [],
  },

  getters: {
    getAntecedentesHeredoFamiliares: (state) => state.antecedentesHeredoFamiliares,
  },

  mutations: {
    SET_ANTECEDENTES_HEREDOFAMILIARES(state, antecedentesHeredoFamiliares) {
      state.antecedentesHeredoFamiliares = antecedentesHeredoFamiliares;
    },
  },

  actions: {
    async fetchAntecedentesHeredoFamiliares({ commit }, idHistoriaClinica) {
      await axios
        .get(`PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/antecedentesHeredoFamiliares`)
        .then((response) => {
          commit('SET_ANTECEDENTES_HEREDOFAMILIARES', response.data.data);
        });
    },

    async saveAntecedentesHeredoFamiliares(context, antecedentesHeredoFamiliares) {
      const { idHistoriaClinica } = context.rootState.historiaClinica;

      await Promise.all(
        antecedentesHeredoFamiliares.map(async (antecedente) => {
          const response = await axios.post(
            `PoliciaCuadrantes/C3/historiaClinica/${idHistoriaClinica}/antecedentesHeredoFamiliares`,
            antecedente,
          );
          return response;
        }),
      );
    },

    async updateAntecedentesHeredoFamiliares(_, antecedentesHeredoFamiliares) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/historiaClinica/${
            antecedentesHeredoFamiliares.fk_idHistoriaClinica
          }/antecedentesHeredoFamiliares/${
            antecedentesHeredoFamiliares.fk_idAntecedentesHeredoFamiliares}`,
          antecedentesHeredoFamiliares,
        );
    },
  },
};
